module.exports = __webpack_public_path__ + "static/img/小红书.a6bde353.png";